// @flow
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { withSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import { DialogContent, CircularProgress, Typography } from '@material-ui/core';

import { users } from '../../services/api/ava';
import * as segment from '../../utils/segment';
import { updateUser, scribeDeselectTranscriptWord } from '../../actions';
import { getSnack } from '../../utils/snackbar';

import Transition from '../../components/Transition';

type Props = {
  action?: string,
  close: Function,
  defaultUserName?: string,
  open: Function,
  scribeDeselectTranscriptWord: Function,
  subtitle?: string,
  t: Function,
  title?: string,
  updateUser: Function,
  user: Object,
  userNameFromUrl?: string,
};

type State = {
  submitting: boolean,
  userName?: string,
};

class EditProfileModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      submitting: false,
      userName: undefined,
    };
  }

  async componentDidMount() {
    // eslint-disable-next-line
    const { scribeDeselectTranscriptWord, userNameFromUrl, user } = this.props;
    if (user.userName === 'web guest' && userNameFromUrl) {
      await this.setState({ userName: userNameFromUrl });
      this.submit();
    }
  }

  componentWillUpdate(nextProps: Props) {
    if (nextProps.open) {
      scribeDeselectTranscriptWord();
    }
  }

  handleChange = (ev: any) => {
    this.setState({ userName: ev.target.value });
  };

  submit = (ev?: Object) => {
    if (ev) {
      ev.preventDefault();
    }
    // eslint-disable-next-line
    const { close, user, updateUser, t } = this.props;
    const { userName } = this.state;
    if (userName === undefined) {
      close();
      return;
    }
    if (userName === '') {
      getSnack(this.props)(t('profilModal.invalidUserName'), {
        variant: 'error',
      });
      return;
    }
    this.setState({ submitting: true });
    const { avaId, firebaseAuthUID, id } = user;

    users
      .updateUserName({
        avaId,
        firebaseAuthUID: firebaseAuthUID || id,
        userName,
      })
      .then(res => {
        this.setState({ submitting: false });
        if (res.status === 200) {
          updateUser({ userName });
          getSnack(this.props)(t('profilModal.profilUpdated'), {});
          close({ updated: true });
          segment.track('Updated Name', { Name: userName });
          segment.identify({ name: userName });
        } else {
          getSnack(this.props)(t('profilModal.failToUpdateProfil'), {
            variant: 'error',
          });
          Sentry.captureException('updateProfilError', res.status, res, user);
        }
      });
  };

  isValid() {
    const { userName } = this.state;
    return userName && userName.length >= 2;
  }

  render() {
    const { action, close, defaultUserName, open, subtitle, t, title, user } = this.props;
    const { submitting } = this.state;
    let defaultNameValue = defaultUserName === undefined ? user.userName : defaultUserName;
    if (defaultNameValue === 'web guest') {
      defaultNameValue = '';
    }
    return (
      <form
        onSubmit={ev => {
          this.submit(ev);
        }}
      >
        <Dialog
          open={open}
          TransitionComponent={Transition}
          onClose={() => close({ updated: false })}
          PaperProps={{
            style: {
              WebkitAppRegion: 'no-drag',
            },
          }}
        >
          <DialogContent>
            <Typography variant="h6">{title || t('profilModal.profilSettings')}</Typography>
            <Typography variant="subtitle1" style={{ color: 'grey' }}>
              {subtitle}
            </Typography>
            <Input
              defaultValue={defaultNameValue}
              onChange={this.handleChange}
              autoFocus
              id="userName"
              style={{ maxWidth: 300, margin: 'auto' }}
              onFocus={event => event.target.select()}
              onKeyDown={ev => {
                if (['Enter'].includes(ev.key)) {
                  this.submit(ev);
                }
              }}
            />
          </DialogContent>
          <DialogActions>
            {!submitting && (
              <>
                <Button variant="text" onClick={() => close({ updated: false })}>
                  {t('profilModal.cancel')}
                </Button>
                <Button
                  disabled={submitting || !this.isValid()}
                  variant="contained"
                  type="submit"
                  onClick={this.submit}
                  color="primary"
                >
                  {action || t('profilModal.save')}
                </Button>
              </>
            )}
            {submitting && <CircularProgress />}
          </DialogActions>
        </Dialog>
      </form>
    );
  }
}

export default connect(
  ({ scribeSession: { captioner, userNameFromUrl } }) => ({
    user: captioner,
    userNameFromUrl,
  }),
  { updateUser, scribeDeselectTranscriptWord }
)(withSnackbar(withTranslation()(EditProfileModal)));
